import CustomButton from "__utilities/components/CustomButton";
import Popup from "__utilities/components/Popup";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { downloadPDFFile } from "__utilities/functions/public";
import { AppConfig } from "AppConfig";
import { ProgressStepper, ProgressStep } from "@patternfly/react-core";
import InProgressIcon from "@patternfly/react-icons/dist/esm/icons/in-progress-icon";
import PendingIcon from "@patternfly/react-icons/dist/esm/icons/pending-icon";
import SuccessIcon from "@patternfly/react-icons/dist/esm/icons/check-circle-icon";
import ErrorIcon from "@patternfly/react-icons/dist/esm/icons/warning-triangle-icon";
import "@patternfly/react-core/dist/styles/base.css";
import { overlayContext } from "_data/context/overlay";
import { logEvent } from "analytics/analytics";

export default function DownloadPopup({ progress, clearSessionStorage }) {
  const { setOverlay } = useContext(overlayContext);
  const navigate = useNavigate();

  const refreshPage = () => {
    navigate("/");
    window.location.reload();
  };
  const getVariant = (status) => {
    switch (status) {
      case "Completed":
        return "success";
      case "Pending":
        return "pending";
      case "Failed":
        return "danger";
      default:
        return "default";
    }
  };

  const getIcon = (status) => {
    switch (status) {
      case "Completed":
        return <SuccessIcon />;
      case "Failed":
        return <ErrorIcon />;
      case "InProgress":
        return <InProgressIcon />;
      case "Pending":
        return <PendingIcon />;
      default:
        return <></>;
    }
  };

  const getHeading = (status) => {
    switch (status) {
      case "Completed":
        return "Din ekstrakt er klar";
      case "Failed":
        return "Der opstod en fejl";
      default:
        return "Vi opretter din ekstrakt";
    }
  };

  return (
    <Popup styles={"w-[70%] tall:w-[60%] py-[40px]"}>
      <div className="flex flex-col w-full items-center relative gap-y-6">
        {progress.status === "Failed" && (
          <div
            className="flex flex-col absolute z-50 top-0 right-0 mr-4 cursor-pointer"
            onClick={() => setOverlay({ show: false, content: <></> })}
          >
            <img className="content-closeIcon scale-125" alt="" />
          </div>
        )}

        <p className="text-primaryBlue font-latoBold text-[22px] text-center">
          {getHeading(progress.status)}
        </p>

        <div className="h-[1px] w-full bg-[#F0F3F5]" />

        <div className="flex flex-col w-full items-center justify-center">
          <ProgressStepper
            isCenterAligned={true}
            className="pf-m-show-progress"
          >
            {progress.steps.map((step) => (
              <ProgressStep
                key={step.number}
                isCurrent={step.status === "InProgress"}
                variant={`${getVariant(step.status)}`}
                icon={getIcon(step.status)}
                id={`extract-progress-step-${step.number}`}
                titleId={`extract-progress-step-${step.number}-title`}
                description={
                  step.status === "InProgress" ? step.description : ""
                }
                className={
                  step.status === "InProgress"
                    ? "pf-v5-c-progress-stepper__step-icon-rotating"
                    : ""
                }
                style={{
                  "--pf-v5-c-progress-stepper__step-percent":
                    step.status === "InProgress" ? step.percentage : 0,
                }}
              >
                {step.title}
              </ProgressStep>
            ))}

            <ProgressStep
              variant={`${getVariant(progress.status)}`}
              icon={
                progress.status === "Completed"
                  ? getIcon("Completed")
                  : getIcon("Pending")
              }
              id="extract-progress-step-final"
              titleId="extract-progress-step-final-title"
            >
              Færdig
            </ProgressStep>
          </ProgressStepper>
        </div>

        {progress.status === "Failed" && (
          <div className="text-red-600">
            <p>{progress.errorMessage}</p>
          </div>
        )}

        {progress?.token && (
          <CustomButton
            onClick={() => {
              logEvent(
                "download_new_extract",
                "app_extract_download",
                "download_button",
              );
              window.onbeforeunload = null;
              downloadPDFFile(
                `${AppConfig.SERVICE_BASE_URL}/api/v1/extract/download/${progress.token}`,
              );
              clearSessionStorage();
              refreshPage();
            }}
            styles={"w-2/3"}
          >
            <span className="mr-2">Download ekstrakt</span>
            <img className="content-downloadIconWhite" alt="" />
          </CustomButton>
        )}
      </div>
    </Popup>
  );
}
